import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { grey25 } from '@zocdoc/branding/colors';
import { Close } from '@zocdoc/components/src/icons';
import { injectKeyHandler, Keys } from '@zocdoc/components/src/KeyHandler';
import { ModalOverlay } from '@zocdoc/components/src/modal';

import { LOCALIZED_STRINGS } from './constants';
import { InteractionLabels } from '../../middleware/google-analytics';

const GALLERY_MARGIN = 16;

const StyledOverlay = styled(ModalOverlay)`
    opacity: 0.9;
`;

const StyledOverlayContent = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 12;
`;

const StyledOverlayControl = styled.div`
    margin: ${GALLERY_MARGIN}px;
    vertical-align: middle;
    cursor: pointer;
    display: inline-block;
    min-width: 28px;
    min-height: 28px;
`;

const StyledOverlayClose = styled.div`
    padding: ${GALLERY_MARGIN}px;
    position: fixed;
    top: 0;
    right: 0;
    text-align: right;
    z-index: 12;
`;

const StyledCloseIcon = styled(Close)`
    margin-top: 5px;
`;

class BaseOverlayView extends Component {
    static propTypes = {
        onClickClose: PropTypes.func.isRequired,
    };

    render() {
        const { intl, children, onClickClose } = this.props;

        return (
            <div data-test="profile-overlay-container">
                <StyledOverlay data-test="profile-overlay" />

                <StyledOverlayContent>
                    {children}
                </StyledOverlayContent>

                <StyledOverlayClose data-test="profile-overlay-close">
                    <StyledOverlayControl>
                        <StyledCloseIcon
                            aria-label={intl.formatMessage(LOCALIZED_STRINGS.Close)}
                            color={grey25}
                            height={18}
                            onClick={onClickClose}
                            role="button"
                            tabIndex="0"
                        />
                    </StyledOverlayControl>
                </StyledOverlayClose>
            </div>
        );
    }
}

export const OverlayView = injectKeyHandler({
    [Keys.ESCAPE]: ({ onClickClose }) => onClickClose({ interaction: InteractionLabels.Keyboard }),
})(
    injectIntl(BaseOverlayView)
);
